export default __webpack_public_path__ + "static/media/reindeer.86c7e23c.png";